module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 18,
      "sm": 18,
      "md": 12
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.contents.intro)
    }
  }), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.contents.repoSelectHint,
      "prop": "repo"
    }
  }, [_c('el-select', {
    staticClass: "block",
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.repo),
      callback: function($$v) {
        _vm.form.repo = $$v
      },
      expression: "form.repo"
    }
  }, _vm._l((_vm.contents.repos), function(repo, index) {
    return _c('el-option', {
      key: repo.github,
      attrs: {
        "label": repo.name,
        "value": repo.name
      }
    })
  }))], 1), _c('el-form-item', {
    attrs: {
      "label": _vm.contents.issueTypesHint,
      "prop": "type"
    }
  }, [_c('el-select', {
    staticClass: "block",
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.form.type = $$v
      },
      expression: "form.type"
    }
  }, _vm._l((_vm.contents.issueTypes), function(type) {
    return _c('el-option', {
      key: type,
      attrs: {
        "label": type,
        "value": type
      }
    })
  }))], 1), _c('el-form-item', {
    attrs: {
      "label": _vm.contents.issueTitleHint,
      "prop": "title"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.form.title = $$v
      },
      expression: "form.title"
    }
  })], 1), (_vm.isBug) ? [_c('el-form-item', [_c('small', [_c('p', {
    domProps: {
      "textContent": _vm._s(_vm.contents.issueUsage)
    }
  }), _c('ul', _vm._l((_vm.contents.links[_vm.form.repo]), function(l) {
    return _c('li', {
      key: "l.link"
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(l.desc)
      }
    }), _c('a', {
      attrs: {
        "href": l.link
      },
      domProps: {
        "textContent": _vm._s(l.link)
      }
    })])
  })), _c('b', {
    domProps: {
      "textContent": _vm._s(_vm.contents.issueHint)
    }
  })])]), _c('el-form-item', {
    attrs: {
      "label": _vm.contents.versionRepositoryHint,
      "prop": "versionRepository"
    }
  }, [_c('el-select', {
    staticClass: "block",
    attrs: {
      "filterable": "filterable",
      "loading": _vm.loading.repository,
      "no-match-text": _vm.contents.noMatchText,
      "no-data-text": _vm.contents.noDataText,
      "placeholder": ""
    },
    model: {
      value: (_vm.form.versionRepository),
      callback: function($$v) {
        _vm.form.versionRepository = $$v
      },
      expression: "form.versionRepository"
    }
  }, _vm._l((_vm.version.repo), function(tag) {
    return _c('el-option', {
      key: tag,
      attrs: {
        "label": tag,
        "value": tag
      }
    })
  }))], 1), _c('el-form-item', {
    attrs: {
      "label": _vm.contents.versionBrowserHint,
      "prop": "versionBrowser"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.versionBrowser),
      callback: function($$v) {
        _vm.form.versionBrowser = $$v
      },
      expression: "form.versionBrowser"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": _vm.contents.versionWechatHint,
      "prop": "versionWechat"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.versionWechat),
      callback: function($$v) {
        _vm.form.versionWechat = $$v
      },
      expression: "form.versionWechat"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": _vm.contents.stepsHint,
      "prop": "steps"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5,
        maxRows: 10
      }
    },
    model: {
      value: (_vm.form.steps),
      callback: function($$v) {
        _vm.form.steps = $$v
      },
      expression: "form.steps"
    }
  })], 1), _c('el-form-item', [_c('small', {
    domProps: {
      "innerHTML": _vm._s(_vm.contents.stepsHintSmall)
    }
  })]), _c('el-form-item', {
    attrs: {
      "label": _vm.contents.expectHint,
      "prop": "expect"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5,
        maxRows: 10
      }
    },
    model: {
      value: (_vm.form.expect),
      callback: function($$v) {
        _vm.form.expect = $$v
      },
      expression: "form.expect"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": _vm.contents.actualHint,
      "prop": "actual"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5,
        maxRows: 10
      }
    },
    model: {
      value: (_vm.form.actual),
      callback: function($$v) {
        _vm.form.actual = $$v
      },
      expression: "form.actual"
    }
  })], 1)] : [_c('el-form-item', {
    attrs: {
      "label": _vm.contents.descHint,
      "prop": "desc"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5,
        maxRows: 10
      }
    },
    model: {
      value: (_vm.form.desc),
      callback: function($$v) {
        _vm.form.desc = $$v
      },
      expression: "form.desc"
    }
  })], 1)], _c('el-form-item', {
    staticClass: "center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    domProps: {
      "textContent": _vm._s(_vm.contents.preview)
    },
    on: {
      "click": _vm.preview
    }
  })], 1)], 2)], 1)], 1), _c('el-dialog', {
    attrs: {
      "title": _vm.contents.dialog.title
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.issueHTML)
    }
  }), _c('span', {
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    domProps: {
      "textContent": _vm._s(_vm.contents.dialog.button)
    },
    on: {
      "click": _vm.create
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-ae0e796e"}!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content.vue
// module id = 178
// module chunks = 1